import { Box, Stack, Text } from '@ltvco/refresh-lib/theme';

import { BaseCardComponent } from './BaseCardComponent';

interface FamousPersonProps {
  headline: string;
  blurb: string;
}

interface FamousPeopleProps {
  name: string;
  famousPeople?: FamousPersonProps[];
}

export function FamousPeople({ name, famousPeople }: FamousPeopleProps) {
  return (
    <BaseCardComponent title={`Famous People Named ${name}`}>
      <Stack spacing={3} alignItems="flex-start">
        {famousPeople?.map((person) => (
          <Box key={person.headline}>
            <Text variant="h5" fontWeight="semibold" sx={{ mb: 1 }}>
              {person.headline}
            </Text>
            <Text variant="body2">{person.blurb}</Text>
          </Box>
        ))}
      </Stack>
    </BaseCardComponent>
  );
}
